import _ from "lodash";
import { marked } from "marked";
import sanitizeHtml, { IOptions } from "sanitize-html";

import "./styles.css";

export const defaultOptions: IOptions = {
  allowedTags: [
    "b",
    "mark",
    "span",
    "strong",
    "i",
    "em",
    "u",
    "b",
    "s",
    "li",
    "ul",
    "a",
    "ol",
    "p",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "br",
    "table",
    "tbody",
    "thead",
    "tr",
    "td",
    "th",
    "hr",
  ],
  allowedAttributes: {
    a: ["href", "target", "rel"],
    "*": ["style", "class", "data-*"],
  },
  transformTags: {
    a: (tagName, attribs) => {
      return {
        tagName: tagName,
        attribs: {
          ...attribs,
          target: "_blank", // Set target to open in a new tab
          rel: "noopener noreferrer", // Add security attributes for external links
        },
      };
    },
  },
};

const sanitize = (dirty: string, options: IOptions) => ({
  __html: sanitizeHtml(dirty, options),
});

const SanitizeHtml = ({
  html,
  dataTestid,
  options = defaultOptions,
  truncateLines,
  sx,
}: {
  html: string;
  dataTestid?: string;
  options?: IOptions;
  truncateLines?: number;
  sx?: React.CSSProperties;
}) => {
  const styles: React.CSSProperties | undefined = _.isNil(truncateLines)
    ? sx
    : {
        display: "-webkit-box",
        WebkitLineClamp: truncateLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        ...sx,
      };

  return (
    <div
      dangerouslySetInnerHTML={sanitize(
        // replace html symbols with spaces
        marked(html.replace(/&nbsp;/g, " "), {
          breaks: true, // Convert \n to <br>
          gfm: true, // Enable GitHub Flavored Markdown
          async: false,
        }),
        options
      )}
      data-testid={dataTestid}
      className="sanitize-html-wrapper"
      style={styles}
    />
  );
};

export default SanitizeHtml;
